import { Component, inject } from "@angular/core";
import { ToastService } from "src/app/shared/services/toast.service";
import { TegelModule } from "@scania/tegel-angular-17";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "app-toast",
    templateUrl: "./toast.component.html",
    styleUrls: ["./toast.component.scss"],
    standalone: true,
    imports: [TegelModule, AsyncPipe]
})
export class ToastComponent {
  toast = inject(ToastService);
  
  toastClass: string[] = [];
  toastMessage: string = "";
  showsToast: boolean = false;

  dismiss(): void {
    this.toast.dismissToast();
  }
}
